import React, { Component } from 'react';

import Paper from 'material-ui/Paper';

class Dashboard extends Component {
  filterFunction = (filterFunction, filterValue) => {
    if (filterValue) {
      filterFunction(filterValue);
    }
  };

  render() {
    let indicators;

    if (this.props.data) {
      indicators = this.props.data.map((indicator, index) => {
        return (
          <div
            className="col-sm-3"
            onClick={() => this.filterFunction(indicator.updateFilter, indicator.updateFilterValue)}
            key={index}
          >
            <h1 className={`${indicator.uniqueClassName} ${indicator.highlightedClass}`}>
              {indicator.value}
            </h1>
            <p>{indicator.title}</p>
          </div>
        );
      });
    }

    const styles = {
      paper: {
        boxShadow: 'none',
        border: '1px solid rgba(128, 128, 128, 0.3)',
        overflow: 'auto',
        borderRadius: '8px',
      },
    };

    return (
      <div
        className="row dashboard-panel upper-dashboard"
        style={{ marginBottom: '25px', marginTop: '10px' }}
      >
        <Paper zDepth={1} style={styles.paper}>
          <div className="col-sm-12 dashboard-panel-items">
            <div className="row">{indicators}</div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default Dashboard;
